import {getMembers} from "../../api/members";
import {getBookings} from "../../api/booking";
import {setBookings, setGolfCourses, setLoading} from "../../useAppPullState";
import {syncUserBookings} from "./syncUserBookings";

export const syncWithServer = () => {
    setLoading(true);
    getMembers(async data => {
        await syncUserBookings();
        if (data.data.status) {
            // console.log({ data });
            setGolfCourses(data.data.response);
            getBookings(null, data => {
                if (data.data.status) {
                    setBookings(data.data.response);
                }
                // dispatch(setReloadData(false));
                setLoading(false);
            });
        }
    });
}
